import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ConfigService, ListadaAgrupada } from '../../../infrastructure/services/config.service';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs';

@Component({
  selector: 'sx-configurar-customer',
  templateUrl: './configurar.customer.component.html',
})
export class CustomersConfiguration implements OnInit {
  title: 'CUSTOMER_CONFIGURATION';
  codOrganization: string;
  codSitema: string;
  codNegocio: string;
  codProducto: string;

  grupos: Observable<ListadaAgrupada[]>;
  cargando: Boolean = true;
  subsGetConfiguracion: Subscription;
  constructor(private aRoute: ActivatedRoute, private configService: ConfigService) { }

  ngOnInit() {
    const { title } = this.aRoute.snapshot.data;
    if (title) {
      this.title = title;
    }

    this.aRoute.params.subscribe((params: Params) => {
      // Parametros URL
      this.codOrganization = params['codorganizacion'];
      this.codSitema = params['codsistema'];
      this.grupos =this.configService.getConfiguracion(
        this.codOrganization,
        this.codSitema, 
        this.codNegocio, 
        this.codProducto).
      map(res => res.filter(x => x.subcat === 'Customer'));
  });
  }

}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/configuracion/customerTable/configurar.customer.component.ts